<template>
<div class="partner">
    <indexTitle english_title="Partner" chinese_title="廠商專區" page='true'></indexTitle>
    <div class="partner_center">
        <a class="partner_box" :href="item.image_button_url" target="_blank"  v-for="item in partner" :key="item.id">
            <div class="partner_img"><img :src="item.image" alt=""></div>
            <div class="partner_text">
                <a :href="item.title_url" target="_blank">
                    <p class="partner_title">{{item.title}}</p>
                </a>
                <p class="partner_date"><i class="fa fa-calendar"></i>{{item.date}}</p>
                <p class="partner_location"><i class="fa fa-map-marker "></i>{{item.location}}</p>
                <p class="partner_btn">{{item.button_display}}</p>
            </div>
        </a>
    </div>
    <moreButton button_text="返回首頁" button_href="/"></moreButton>
</div>
</template>
<script>
import IndexTitle from '@/components/index/IndexTitle'
import MoreButton from '@/components/index/MoreButton'
export default {
     components: {
        'indexTitle': IndexTitle,
        'moreButton': MoreButton,
    },
    metaInfo: {
      title: '廠商專區 │ TopLink 上聯國際展覽有限公司', // set a title
      meta: [{                 // set meta
        name: 'description',
        keywords: '上聯,展覽,徵展,參展,廠商,合作',
        content: '上聯國際展覽是國內展覽規模第一大的專業展覽公司。主要服務項目為承辦國內外各類型展覽，及展覽徵展業務、議題創意、媒體公關、展覽顧問、整合行銷規劃、國際策展交流等。世貿展,展覽資訊,展覽活動,近期展覽,展覽檔期,展覽公司,展覽好康,抽獎,免費門票'
      }]
    },
    data(){
        return{
            partner:[
                {  
                    "image": 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2020_vegetable2.JPG',
                    "title": "2020素食養生展(招商)",                    
                    "date": "2020-01-01~2020-12-31",
                    "location": "展出地點詳閱內頁",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_vegetable2.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_vegetable2.pdf"
                },
                {  
                    "image": 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/20.JPG',
                    "title": "2020婚紗展(招商)",                    
                    "date": "2020-07-03~2020-12-31",
                    "location": "展出地點詳閱內頁",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_wedding_3.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_wedding_3.pdf"
                },
                {  
                    "image": require('../../assets/partner/15.jpg'),
                    "title": "2020運動用品暨戶外休閒展(招商)",                    
                    "date": "2020-07-03~2020-07-06",
                    "location": "展出地點詳閱內頁",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_sport.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_sport.pdf"
                },
                {  
                    "image": require('../../assets/partner/16.jpg'),
                    "title": "2020台北國際探險用品展(招商)",                    
                    "date": "2020-07-03~2020-07-06",
                    "location": "展出地點詳閱內頁",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_traveling.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_traveling.pdf"
                },
                {  
                    "image": 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2020_mombaby.JPG',
                    "title": "2020國際級婦幼展(招商)",                    
                    "date": "2020-06-25~2020-12-31",
                    "location": "展出地點詳閱內頁",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_mombaby.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_mombaby.pdf"
                },
                {  
                    "image": "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2020_stationery.JPG",
                    "title": "台北創意文具展",                    
                    "date": "2020-07-03~2020-07-06",
                    "location": "台北世貿一館",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://www.top-link.com.tw/uploadfiles/99/upload/files/2020_stationery.pdf",
                    "image_button_url": "https://www.top-link.com.tw/uploadfiles/99/upload/files/2020_stationery.pdf"
                },
                {  
                    "image": "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2020_pet.JPG",
                    "title": "2020寵物用品博覽會徵展企畫書",                    
                    "date": "2020-07-31~2020-12-31",
                    "location": "展出地點詳閱內頁",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_pet.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_pet.pdf"
                },
                {  
                    "image": "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2020_travel2.JPG",
                    "title": "2020台中烏日國際旅遊展",                    
                    "date": "2020-09-18~2020-12-28",
                    "location": "展出地點詳閱內頁",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_travel2.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_travel2.pdf"
                },
                {  
                    "image": require('../../assets/partner/18.jpg'),
                    "title": "第十三屆台北國際健康產業博覽會(招商)",                    
                    "date": "2020-08-21~2020-08-24",
                    "location": "展出地點詳閱內頁",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://www.top-link.com.tw/uploadfiles/99/upload/files/2020_health.pdf",
                    "image_button_url": "https://www.top-link.com.tw/uploadfiles/99/upload/files/2020_health.pdf"
                },
                {  
                    "image": 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2020_3C_game.JPG',
                    "title": "2020年度台北3C展徵展企畫書",                    
                    "date": "2020-09-04~2020-09-07",
                    "location": "台北世貿一館",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_3C_game.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_3C_game.pdf"
                },
                
                {  
                    "image": "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2020_face.JPG",
                    "title": "2020台北國際美容美甲美髮展暨韓國美容展",                    
                    "date": "2020-08-07~2020-08-10",
                    "location": "台北世貿一館",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_face.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_face.pdf"
                },
                {  
                    "image": "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2020_structure.JPG",
                    "title": "2020台灣國際建築．建材．廚具空間設計展",                    
                    "date": "2020-08-07~2020-08-10",
                    "location": "台北世貿一館",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_structure.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_structure.pdf"
                },
                {  
                    "image": "https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2020_food.JPG",
                    "title": "2020台北食品暨美食國際博覽會徵展企畫書",                    
                    "date": "2020-08-28~2020-12-31",
                    "location": "展出地點詳閱內頁",
                    "button_display": "下載徵展企畫書",
                    "title_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_food2.pdf",
                    "image_button_url": "https://cdn.top-link.com.tw/uploadfiles/99/upload/files/2020_food2.pdf"
                },
                // {  
                //     "image": "",
                //     "title": "",                    
                //     "date": "",
                //     "location": "",
                //     "button_display": "下載徵展企畫書",
                //     "title_url": "",
                //     "image_button_url": ""
                // },
            ],
        }
    },
    mounted(){
        // var apitime = new Date();
        this.partner.sort(sortNumber)
        function sortNumber(a,b){
            return parseInt(a.date.slice(0, 10).replace(/[^\d.]/g,''))-parseInt(b.date.slice(0, 10).replace(/[^\d.]/g,''))
        }
        this.partner= this.partner.filter(function(item){
            return new Date(item.date.slice(11))>=new Date();
        });

    }
}
</script>
<style scoped>
.partner{
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
    text-align: center;
}
.partner a{
    text-decoration: none;
    color:black;
}
.partner_center{
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
}
.partner_box{
    display: flex;
    width: 33.3%;
    box-sizing: border-box;
    padding: 10px;
    justify-content: center;
    align-items: center;
}
.partner_img{
    flex:1;
    /* display: flex; */

}
.partner_img img{
    width: 100%;
}
.partner_text{
    flex:2;
}
.partner_title{
    color:#00a0e9;
    font-weight: 700;
    font-size: 17px;
    text-align: left;
    margin-left: 10px;
}
.partner_date{
    font-size: 15px;
    text-align: left;
    margin-left: 10px;
}
.partner_date i{
    width: 15px;
    height: 15px;
    text-align: center;
    margin: 5px 5px 0 0;
}
.partner_location{
    font-size: 15px;
    text-align: left;
    margin-left: 10px;
}
.partner_location i{
    width: 15px;
    height: 15px;
    text-align: center;
    margin: 5px 5px 0 0;
}
.partner_btn{
    color:#00a0e9;
    font-size: 15px;
    text-align: left;
    margin-left: 10px;
}
/* 1152 */
@media (max-width: 1152px){
    .partner_box{
        width: 50%;
    }
}
@media (max-width: 768px){
    .partner_box{
        width: 80%;
    }
    .partner_center{
        padding: 0;
    }
}
@media (max-width: 500px){
    .partner_box{
        width: 100%;
    }
    .partner_img{
        flex:5;
    }
    .partner_text{
        flex:7;
        
    }
}
</style>


